import React, { useState } from 'react';
import styles from './medium-reel-card.module.css';
import { MediaItem } from '../../types';
import { getEmbedSrc, getYouTubeId } from '../../utils/media-utils';

interface MediumReelCardProps {
  item: MediaItem;
  onPlay?: (item: MediaItem) => void;
}

export default function MediumReelCard({ item, onPlay }: MediumReelCardProps) {
  const [showEmbed, setShowEmbed] = useState(false);

  const trackEvent = (eventName: string, additionalParams: Record<string, unknown> = {}) => {
    window.analytics?.trackEvent(eventName, {
      media_id: item.a_id || item.id,
      media_title: item.title,
      media_type: 'reel',
      media_outlet: item.outlet?.name,
      media_url: item.linkUrl,
      media_location: 'home_media_section',
      ...additionalParams
    });
  };

  const handlePlayClick = (e: React.MouseEvent) => {
    e.preventDefault();
    trackEvent('media_watch', {
      method: onPlay ? 'embed_play_overlay' : 'embed_play'
    });
    if (onPlay) {
      onPlay(item);
    } else {
      setShowEmbed(true);
    }
  };

  const handleLinkClick = () => {
    trackEvent('media_click', { url: item.linkUrl });
  };

  const getThumbUrl = () => {
    const imageIsVideoUrl = item.imageUrl && (item.imageUrl.includes('youtube') || item.imageUrl.includes('youtu.be'));
    if (item.imageUrl && !imageIsVideoUrl) {
      return item.imageUrl;
    }
    const videoId = (item.embedUrl ? getYouTubeId(item.embedUrl) : null) || (item.linkUrl ? getYouTubeId(item.linkUrl) : null);
    if (videoId) {
      return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    }
    return item.imageUrl;
  };

  const thumbUrl = getThumbUrl();
  const embedSrc = item.embedUrl || item.linkUrl;
  const finalEmbedUrl = getEmbedSrc(embedSrc);

  return (
    <div className={styles.card}>
      <div className={styles.mediaContainer}>
        {showEmbed ? (
          <iframe
            src={finalEmbedUrl}
            title={item.title}
            className={styles.iframe}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <a
            href={item.linkUrl}
            className={styles.imageLink}
            onClick={handlePlayClick}
          >
            <img
              src={thumbUrl}
              alt={item.title}
              className={styles.image}
            />
            <div className={styles.playOverlay}>
              <div className={styles.playButton}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className={styles.playIcon}
                >
                  <path
                    fillRule="evenodd"
                    d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
            <div className={styles.titleOverlay}>
              <h3 className={styles.title}>{item.title}</h3>
            </div>
          </a>
        )}
      </div>
    </div>

  );
}
